module.exports = __webpack_public_path__ + "img/school6.db841873.png";